var g_utf8Enc = new TextEncoder();
var g_utf8Dec = new TextDecoder();
export function stringToBytes(s) {
    return g_utf8Enc.encode(s);
}
export function bytesToString(s) {
    return g_utf8Dec.decode(s);
}
export class Verdict {
    accept() {
        // SMS peer, then report success to helper
    }
}
export class NegAnnouncer {
    constructor(conn, role, pub) {
        this.conn = conn;
        this.announceSubj = "neg.announce." + role + "." + pub;
        if (this.announceSubj != undefined) {
            this.send({ "new": true });
            this.ticker = setInterval(() => {
                this.send({});
            }, 15000);
        }
    }
    send(data) {
        this.conn.publish(this.announceSubj, stringToBytes(JSON.stringify(data)));
    }
    stop() {
        clearInterval(this.ticker);
    }
}
export const SelectArbiterTopic = "selarb";
export const TunnelUpdateTopic = "upd";
export function parseAnnounce(announce) {
    let parts = announce.split('.');
    return { pubKey: parts[3], role: parts[2] };
}
export function parseSms(subj) {
    //"neg.topic.sms.senderRole.sender"
    let parts = subj.split('.');
    return { topic: parts[1], senderRole: parts[3], sender: parts[4] };
}
export function parseTunnel(subj) {
    //"neg.tunnel.helper.streamer.viewer"
    let parts = subj.split('.');
    return { helper: parts[2], streamer: parts[3], viewer: parts[4] };
}
export class ConditionChecker {
    constructor(remainingChecks) {
        this.remainingChecks = remainingChecks;
    }
    update() {
        if (this.checkInProgress) {
            this.needMoreChecks = true;
            return;
        }
        this.needMoreChecks = false;
        this.checkInProgress = true;
        let resolvedSomething = false;
        for (let i in this.remainingChecks) {
            this.remainingChecks[i](() => {
                console.log("Resolved ", i);
                resolvedSomething = true;
                delete this.remainingChecks[i];
            });
        }
        this.checkInProgress = false;
        if (this.needMoreChecks && resolvedSomething) {
            this.update();
        }
    }
}
export function traverse(obj, path) {
    let parts = path.split(".");
    for (let i = 0; i < parts.length; ++i) {
        if (obj == undefined) {
            return obj;
        }
        obj = obj[parts[i]];
    }
    return obj;
}
